export default "__VITE_ASSET__nCa7qz9t__"